export const MAPLE_VENEER_CABINET_BOX = 'Maple Veneer';
